/**
 * NotFoundPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 */

import React from 'react';
import styled from 'styled-components';
import { CenteredLayout } from '../../components/CenteredLayout';

const H1 = styled.h1`
  font-size: 2em;
  margin-bottom: 0.25em;
`;

export default function NotFound() {
  return (
	<CenteredLayout>
		<article>
		<H1>
			Sivua ei löydy.
		</H1>
		</article>
	</CenteredLayout>
  );
}
